<template>
<div>
  <v-data-table
    :loading="isLoading"
    :headers="headers"
    :items="dataTable"
    :items-per-page="itemPerPage"
    :page="tablePage"
    :footer-props="{'items-per-page-options': [5,10, 100]}"
    :search="search"
    :hide-default-header="true"
    :custom-filter="customFilter"
    no-results-text="查無符合資料"
    class="elevation-1"
  >
    <template v-slot:header="{props}">
      <thead class="v-data-table-header">
        <tr>
          <!-- <th
            v-for="(header, idx) in props.headers"
            :key="`header-${idx}-`+header.text"
            v-show="header.showInMobile || !isMobile"
          >
            <span>{{ header.text }}</span>
          </th> -->

          <th
            v-for="(header, idx) in props.headers"
            :key="`header-${idx}-`+header.text"
            v-show="header.showInMobile || !isMobile"
            :style="{'cursor': header.sortKey ? 'pointer':'initial'}"
            @click="toggleSort(header)"
          >
            <span>{{ header.text }}</span>
            <v-chip
              v-if="header.sortKey"
              v-show="sorting[header.sortKey].index > 0"
              x-small
              style="width: 16px;padding: 0 4px;"
            >{{sorting[header.sortKey].index}}</v-chip>
            <v-icon
              v-if="header.sortKey"
              v-show="sorting[header.sortKey].index > 0 && sorting[header.sortKey].order == 'desc'"
              x-small
            >mdi-arrow-down</v-icon>
            <v-icon
              v-if="header.sortKey"
              v-show="sorting[header.sortKey].index > 0 && sorting[header.sortKey].order == 'asc'"
              x-small
            >mdi-arrow-up</v-icon>
          </th>
        </tr>
      </thead>
    </template>
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>{{pageTitle}}</v-toolbar-title>
        <!-- <v-divider class="mx-4" inset vertical></v-divider>
        <span class="d-none d-sm-flex">權限: 主管以上</span> -->
        <v-spacer></v-spacer>
        <v-text-field
          v-model="delaySearch"
          @input="onDelaySearchInput"
          append-icon="search"
          label="搜尋名稱、案號"
          single-line
          hide-details
        ></v-text-field>
        <v-spacer></v-spacer>

        <v-tooltip
          top
        >
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              dark
              class="mb-2 ml-1 mr-1"
              small
              @click.stop="isShowFilterDialog = true"
            >
              <v-badge color="primary" v-if="filterConditionCount > 0">
                <template v-slot:badge><span primary>{{filterConditionCount}}</span></template>
                <v-icon x-small>mdi-filter-menu</v-icon>
              </v-badge>
              <v-icon v-else x-small>mdi-filter-menu</v-icon>
            </v-btn>
          </template>
          <span>進階篩選</span>
        </v-tooltip>
        <v-spacer></v-spacer>

        <v-btn
          v-if="myLevel>=10"
          color="primary"
          dark
          class="mb-2 ml-1 mr-1"
          :disabled="isExporting"
          @click.stop="exportExcel"
        >
          <v-icon>mdi-cloud-download</v-icon>
        </v-btn>
        <v-btn
          v-if="canEditProject"
          color="primary"
          dark
          class="mb-2 ml-1 mr-1"
          @click="create"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>

      </v-toolbar>
    </template>

    <template v-slot:item="{item}">
      <project-list-item
        :item="item"
        :key="`item-${item.ID}`"
        @remove="deleteItem"
      />
    </template>

    <!-- 2023/07/19 TODO: reset 應該要做些什麼吧... -->
    <template v-slot:no-data>
      <v-btn
        color="primary"
        @click="reloadDataTable"
      >Reset</v-btn>
    </template>
  </v-data-table>

  <project-filter-dialog
    v-model="isShowFilterDialog"
    :filter-condition="filterCondition"
    @updated="onFilterUpdated"
  />
  <project-addedit-dialog
    v-model="$store.state.UI.dialog.projectEditor.isShow"
    :id="$store.state.UI.dialog.projectEditor.id"
    @close="$store.state.UI.dialog.projectEditor.isShow=false"
    @updated="reloadDataTable"
  />

  <v-snackbar
    v-model="isDataRefetched"
    :timeout="-1"
  >
    偵測到資料已更新
    <v-btn
      class="ml-1 mr-1"
      color="pink"
      text
      @click="isDataRefetched = false"
    >
      關閉
    </v-btn>
    <v-btn
      class="ml-1 mr-1"
      color="white"
      text
      @click="reloadDataTable"
    >
      重新載入
    </v-btn>
  </v-snackbar>

  <excel-export-progress-dialog
    :show="exportProgress.show"
    :phase="exportProgress.phase"
    :current="exportProgress.current"
    :total="exportProgress.total"
    :error="exportProgress.error"
    @close="closeExportProgress"
  />
</div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import filterMixin from "@/data/filters/filter-mixin.vue";
import ProjectListItem from "./project-list-item.vue";
import XMLGenerator from "@/data/excel/xml-generator-project.js";
import ExcelExportProgressDialog from "@/ui/components/excel-export-progress-dialog.vue";
import mixinExcelExportWithProgress from "@/ui/mixin-excel-export-with-progress.vue";
import ProjectAddeditDialog from "@/ui/project/project-addedit-dialog.vue";
// filter
import advanceFilterMixin from "@/utils/mixin-vuetify-datatable-filter.vue";
import ProjectFilterDialog from "./project-filter-dialog.vue";

import { getProjectFullID } from "@/data/filters/formatter.js";
import mixinDelaySearch from "@/ui/mixin-datatable-delaysearch.vue";
export default {
  mixins: [filterMixin, advanceFilterMixin, mixinDelaySearch, mixinExcelExportWithProgress],
  components: {
    ProjectListItem,
    ProjectFilterDialog,
    ProjectAddeditDialog,
    ExcelExportProgressDialog,
  },
  data: () => ({
    isLoading: false,
    dataTable: [],
    pageTitle: "專案",
    itemPerPage: 10, // -1 is all, default is 10, 5 is fine.
    tablePage: 1,
    search: "",
    // data refetched
    isDataRefetched: false,
    // sorting
    sorting: {
      date: {
        order: "desc",
        index: 1
      },
      user: {
        order: null,
        index: -1
      },
      manager: {
        order: null,
        index: -1
      },
      status: {
        order: null,
        index: -1
      },
      money: {
        order: null,
        index: -1
      },
      name: {
        order: null,
        index: -1
      },
      client: {
        order: null,
        index: -1
      }
    },
  }),
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.name === "xs";
    },
    headers() {
      return [
        {
          text: "專案名稱",
          value: "-",
          sortKey: 'name',
          showInMobile: true
        },
        { text: "案號", value: "project-full-id" },
        { text: "負責人", value: "-", sortKey: 'manager' },
        { text: "客戶", value: "-", sortKey: 'client' },
        { text: "建立日期", value: "created-date", sortKey: 'date' },
        { text: "金額", value: "money", sortKey: 'money' },
        { text: "狀態", value: "Status", showInMobile: true, sortKey: 'status' },
        { text: "操作", value: "action", showInMobile: true }
      ];
    },
    sortings() {
      let arr = [];
      for (let key in this.sorting) {
        if (this.sorting[key].index > 0)
          arr.push({
            key: key,
            order: this.sorting[key].order,
            index: this.sorting[key].index
          });
      }
      arr = arr.sort((o1, o2) => o1.index - o2.index);
      return arr;
    },
    ...mapGetters(["me", "canEditProject", "myLevel"])
  },
  methods: {
    toggleSort(header) {
      if (!header.sortKey) return;
      if (this.sorting[header.sortKey].index <= 0) {
        this.sorting[header.sortKey].index = this.sortings.length + 1;
        this.sorting[header.sortKey].order = "desc";
      } else if (this.sorting[header.sortKey].order == "desc") {
        this.sorting[header.sortKey].order = "asc";
      } else if (this.sorting[header.sortKey].order == "asc") {
        this.sorting[header.sortKey].index = -1;
        this.sorting[header.sortKey].order = null;
      } else {
        window.console.error(`toggleSort, unknown status`);
      }
      this.reloadDataTable();
    },
    async exportExcel() {
      const datas = this.dataTable.filter(
        o => !this.search || this.customFilter('value-whatever', this.search, o)
      );

      const fileName = window.prompt(
        "請輸入匯出Excel檔之名稱",
        "傳動ERP-專案-匯出"
      );
      if (!fileName) {
        window.alert("請輸入檔案名稱");
        return;
      }

      await this.runExcelExport({
        datas,
        fileName,
        buildSheetData: (items, onProgress) =>
          XMLGenerator.buildSheetData(this, items, onProgress),
      });
    },
    customFilter(value, search, item) {
      return (
        item.Name.includes(search) || getProjectFullID(item).includes(search)
      );
    },
    create() {
      // this.$router.push({ name: "project-creator" });
      this.$store.state.UI.dialog.projectEditor.id = null;
      this.$store.state.UI.dialog.projectEditor.isShow = true;
    },
    deleteItem(item) {
      const removingIdx = this.$store.state.project.list.indexOf(item);
      this.isLoading = true;
      this.$services.project
        .delete(this, item.ID)
        .then(res => {
          this.$store.state.project.list.splice(removingIdx, 1);
          // this.$alertMessage("成功刪除專案「" + item.Name + "」!");
          this.reloadDataTable();
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    reloadDataTable() {
      this.dataTable = this.getDataList()
      this.isDataRefetched = false;
      this.$store.state.project.isReloaded = false;
      this.tablePage = 1
    },
    showProjectDialog(id) {
      this.$store.state.UI.dialog.project.id = id;
      this.$store.state.UI.dialog.project.isShow = true;
    },
    getDataList () {

      const getProjectStatusCode = status => {
        if (status=='招標中') return 1
        if (status=='未得標') return 2
        if (status=='執行中') return 3
        if (status=='已結案') return 4
        if (status=='已完成') return 5
        return 0
      }

      const sortingFunc = (o1, o2) => {
        var result = 0;
        // 依據 this.sortings 修改排序
        for (let sorting of this.sortings) {
          if (sorting.key == "date") {
            let o1TS = moment(moment(o1.CreatedAt).format("YYYY-MM-DD"));
            let o2TS = moment(moment(o2.CreatedAt).format("YYYY-MM-DD"));
            if (sorting.order == "asc") result = o1TS - o2TS;
            else result = o2TS - o1TS;
          } else if (sorting.key == "user") {
            if (sorting.order == "asc") result = o1.UserID - o2.UserID;
            else result = o2.UserID - o1.UserID;
          } else if (sorting.key == "manager") {
            if (sorting.order == "asc") result = o1.ManagerID - o2.ManagerID;
            else result = o2.ManagerID - o1.ManagerID;
          } else if (sorting.key == "money") {
            let o1Value = o1.FinalAmount || o1.Amount
            let o2Value = o2.FinalAmount || o2.Amount
            if (sorting.order == "asc") result = o1Value - o2Value;
            else result = o2Value - o1Value;
          } else if (sorting.key == "status") {
            let o1Value = getProjectStatusCode(o1.Status)
            let o2Value = getProjectStatusCode(o2.Status)
            if (sorting.order == "asc") result = o1Value - o2Value;
            else result = o2Value - o1Value;
          } else if (sorting.key == "name") {
            let o1Value = o1.Name
            let o2Value = o2.Name
                      
            const isStartInNumOrEn = (str) => /[a-zA-Z0-9]/.test(str[0])

            // 英數的權重
            if ((isStartInNumOrEn(o1Value)) != (isStartInNumOrEn(o2Value))) {
              result = isStartInNumOrEn(o1Value) ? -1 : 1
            } else {
              result = o2Value.localeCompare(o1Value, "zh-TW");
            }
            if (result !== 0 && sorting.order != "asc")result = 0-result
          } else if (sorting.key == "client") {
            if (sorting.order == "asc") result = o1.ClientID - o2.ClientID;
            else result = o2.ClientID - o1.ClientID;
          } else {
            window.console.error(`sortingFunc, unknown key ${sorting.key}`);
          }
          if (result !== 0) break;
        }
        return result;
      };

      const filter = o=>{
        if (this.filterCondition.ProjectID && o.ID != this.filterCondition.ProjectID) return false;
        if (this.filterCondition.ClientID && o.ClientID != this.filterCondition.ClientID) return false;
        // if (this.filterCondition.DepartmentID && findTaskWorkingItemDepartmentID(o) != this.filterCondition.DepartmentID) return false;
        if (this.filterCondition.UserID && o.ManagerID != this.filterCondition.UserID) return false;
        // if (!!(this.filterCondition.Date) && !moment(this.filterCondition.Date).isSame(o.Date, "date")) return false;
        return true
      }
      var results = this.$store.state.project.list
      results = results.filter(filter);
      if (this.sortings.length) results = results.sort(sortingFunc);
      return results;
    },
  },
  created() {
    const pageName = 'project-list'
    window.console.log(`${pageName} created`)
    window.console.log(`${pageName} services = `, this.$services)
    window.$services = this.$services
    this.isLoading = true;

    Promise.all([
      this.$services.prepareDatas(this),
      // this.$services.prepareProjectDatas(this) // 20220501 發現 prepareDatas時就會prepareProductDatas
    ])
    .then(function(result) {
      window.console.log(`${pageName} result:`,result)
    })
    .catch(function(error) {
      window.console.error(`${pageName} error:`,error)
    })
    .finally(() => {
      window.console.log(`${pageName} finally`)
      this.reloadDataTable();
      this.isLoading = false;
    });

    let id = parseInt(this.$route.query.id || 0);
    if (id > 0) {
      this.showProjectDialog(id);
    }
  },
  watch: {
    $route(to, from) {
      if (to.query.id != from.query.id) {
        let id = parseInt(to.query.id || 0);
        if (id > 0) {
          this.showProjectDialog(id);
        } else {
          this.$store.state.UI.dialog.project.isShow = false;
        }
      }
    },
    "$store.state.project.isReloaded"() {
      if (
        this.$store.state.project.isFetched &&
        this.$store.state.project.isReloaded
      )
        this.isDataRefetched = true;
    }, search () {
      this.tablePage = 1
    }
  }
};
</script>